module.exports = __webpack_public_path__ + "img/bic.8023ca3e.jpg";